import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c605cec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Keresés")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Barátok")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Vissza")
const _hoisted_4 = { class: "segment-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Barátok")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Kérelmek")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Tiltások")
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " Bejövő kérelmek ", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " Kimenő kérelmek ", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "bottom-absolute"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Nem tiltottál le senkit ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ion-text-center" }, [
  /*#__PURE__*/_createTextVNode("Ha valakit letiltasz, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ezen a listán fog megjelenni.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.friendsModal.open,
    "swipe-to-close": true,
    "show-backdrop": true,
    "presenting-element": _ctx.$root.$refs.mainRouterOutlet.$el,
    onDidDismiss: _ctx.dismiss,
    ref: "friendsModal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.search,
                    class: "f"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.dismiss,
                    class: "l"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "relative" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ion_segment, {
              modelValue: _ctx.slider,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slider) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: "friends" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "requests" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "blocks" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.slider == 'friends')
            ? (_openBlock(), _createBlock(_component_ion_list, {
                key: 0,
                class: "f l"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.friends, (friend) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: friend.id,
                      onClick: ($event: any) => (_ctx.openProfile(friend))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_avatar, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: 
                                './assets/image/avatars/' +
                                friend.username +
                                '.jpg'
                            
                            }, null, 8, _hoisted_8)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(friend.firstName + " " + friend.lastName), 1),
                            (_ctx.hasBirthdayToday(friend.birthday))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Ma van a születésnapja. "))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128)),
                  _createVNode(_component_ion_item, {
                    class: "scrollfix",
                    lines: "none"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.slider == 'requests')
            ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item_divider, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (req) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: req.id,
                          onClick: ($event: any) => (_ctx.openProfile(req))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, { slot: "start" }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: 
                                    './assets/image/avatars/' +
                                    req.username +
                                    '.jpg'
                                
                                }, null, 8, _hoisted_11)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString(req.firstName + " " + req.lastName), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item_divider, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestsOutgoing, (req) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: req.id,
                          onClick: ($event: any) => (_ctx.openProfile(req))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, { slot: "start" }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: 
                                    './assets/image/avatars/' +
                                    req.username +
                                    '.jpg'
                                
                                }, null, 8, _hoisted_13)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString(req.firstName + " " + req.lastName), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, {
                    class: "scrollfix",
                    lines: "none"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.slider == 'blocks')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createVNode(_component_ion_img, {
                  src: './assets/image/no_blocks.png',
                  class: "end-image"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "presenting-element", "onDidDismiss"]))
}